import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-field-checkbox mr-7"
}
const _hoisted_2 = {
  class: "p-field-checkbox-label",
  for: "binary"
}
const _hoisted_3 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_4 = { class: "p-field-checkbox mr-5" }
const _hoisted_5 = {
  class: "p-field-checkbox-label",
  for: "binary"
}
const _hoisted_6 = { class: "p-field-checkbox mr-5" }
const _hoisted_7 = {
  class: "p-field-checkbox-label",
  for: "binary"
}
const _hoisted_8 = {
  key: 0,
  class: "grid _relative"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("rect", {
  width: "1920",
  height: "1440",
  fill: "#ECEDF3"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "ml-auto" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("rect", {
  width: "1920",
  height: "1440",
  fill: "#ECEDF3"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "ml-auto" }, null, -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "col-12 md:col-6 lg:col-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "+", -1)
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Settings = _resolveComponent("Settings")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, null, {
      left: _withCtx(() => [
        (!$setup.isDsplaySettings)
          ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
              _createVNode(_component_Checkbox, {
                modelValue: $setup.isSelectAll,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.isSelectAll) = $event)),
                binary: true,
                value: "all",
                onChange: $setup.toggleAll
              }, null, 8, ["modelValue", "onChange"]),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('vehicles_page.select_all')), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      right: _withCtx(() => [
        ($setup.isSelected && !$setup.isDsplaySettings)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, [
                _createVNode(_component_Checkbox, {
                  modelValue: $setup.selectOriginal,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectOriginal) = $event)),
                  binary: true,
                  value: "original"
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('vehicles_page.with_original_images')), 1)
              ]),
              _createElementVNode("label", _hoisted_6, [
                _createVNode(_component_Checkbox, {
                  modelValue: $setup.selectBanner,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectBanner) = $event)),
                  binary: true,
                  value: "banner"
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('vehicles_page.with_banner')), 1)
              ]),
              _createVNode(_component_Button, {
                onClick: $setup.download,
                class: "p-button-outlined p-button-only-icon p-button-gray mr-2 mb-4 mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, { name: "download" })
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                onClick: $setup.processing,
                class: "p-button-outlined p-button-gray mr-4 mb-4 mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, { name: "upload-cloud" }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('vehicles_page.processing')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          class: "p-button-outlined p-button-secondary mr-2 p-button-only-icon mb-4 mt-5",
          onClick: _cache[3] || (_cache[3] = () => ($setup.isDsplaySettings = !$setup.isDsplaySettings))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, { name: "settings" })
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.deleteVehiclePopup($event))),
          class: "p-button mb-4 mt-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, { name: "trash" }),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('vehicles_page.deleteVehicles')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (!$setup.isDsplaySettings)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          ($setup.state.isLoading)
            ? (_openBlock(), _createBlock(_component_Loader, {
                key: 0,
                isOverlay: !!$setup.data
              }, null, 8, ["isOverlay"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.angles, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "col-12 md:col-6 lg:col-3"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([[_ctx.$style.card], "flex flex-column align-items-center"])
              }, [
                (_openBlock(), _createElementBlock("svg", {
                  class: _normalizeClass(_ctx.$style.substrate),
                  width: "1920",
                  height: "1440",
                  viewBox: "0 0 1920 1440",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _hoisted_10, 2)),
                _createElementVNode("img", {
                  src: item.processed_url || item.loaded_photo || item.car,
                  class: _normalizeClass([_ctx.$style.image, !(item.processed_url || item.loaded_photo) && _ctx.$style.imageReference]),
                  alt: ""
                }, null, 10, _hoisted_11),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex align-items-center w-full mb-5", _ctx.$style.actions])
                }, [
                  _createElementVNode("p", {
                    class: _normalizeClass([_ctx.$style.position, "py-1 px-3 mr-2 _button-2"])
                  }, _toDisplayString(index + 1), 3),
                  _createElementVNode("p", {
                    class: _normalizeClass([_ctx.$style.position, "py-1 px-3 _button-2"])
                  }, _toDisplayString(item.type), 3),
                  _createElementVNode("div", _hoisted_12, [
                    (item.loaded_photo)
                      ? (_openBlock(), _createBlock(_component_Checkbox, {
                          key: 0,
                          onChange: $setup.checkIsSelectedAll,
                          class: _normalizeClass(_ctx.$style.checkbox),
                          modelValue: item.isSelected,
                          "onUpdate:modelValue": ($event: any) => ((item.isSelected) = $event),
                          value: item.id,
                          binary: true
                        }, null, 8, ["onChange", "class", "modelValue", "onUpdate:modelValue", "value"]))
                      : _createCommentVNode("", true)
                  ])
                ], 2),
                (item.status == 1 || item.status == 3)
                  ? (_openBlock(), _createBlock(_component_Loader, {
                      key: 0,
                      isOverlay: true
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: _normalizeClass(_ctx.$style.overlayAction),
                  onClick: () => $setup.openModal(index)
                }, null, 10, _hoisted_13)
              ], 2)
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.extra_photos, (extraPhoto, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12 md:col-6 lg:col-3",
              key: extraPhoto.id
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([[_ctx.$style.card], "flex flex-column align-items-center"])
              }, [
                (_openBlock(), _createElementBlock("svg", {
                  class: _normalizeClass(_ctx.$style.substrate),
                  width: "1920",
                  height: "1440",
                  viewBox: "0 0 1920 1440",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _hoisted_15, 2)),
                _createElementVNode("img", {
                  src: extraPhoto.thumbnail,
                  class: _normalizeClass([_ctx.$style.image]),
                  alt: ""
                }, null, 10, _hoisted_16),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex align-items-center w-full mb-5", _ctx.$style.actions])
                }, [
                  _createElementVNode("p", {
                    class: _normalizeClass([_ctx.$style.position, "py-1 px-3 _button-2"])
                  }, _toDisplayString('Extra'), 2),
                  _hoisted_17
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass(_ctx.$style.overlayAction),
                  onClick: () => $setup.openModal($setup.data.angles.length + index)
                }, null, 10, _hoisted_18)
              ], 2)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", {
              class: _normalizeClass([[_ctx.$style.card, _ctx.$style.addExtra], "flex flex-column align-items-center"])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.addExtraWrap)
              }, _hoisted_21, 2),
              _createElementVNode("input", {
                type: "file",
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.addExtraPhoto && $setup.addExtraPhoto(...args)))
              }, null, 32)
            ], 2)
          ])
        ]))
      : (_openBlock(), _createBlock(_component_Settings, { key: 1 })),
    _createVNode(_component_Dialog, {
      visible: $setup.isShow,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (($setup.isShow) = $event)),
      modal: true,
      draggable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Modal, {
          total: $setup.data.angles.length + $setup.data.extra_photos.length,
          selected: $setup.selectedIndex,
          item: $setup.selectedIndex < $setup.data.angles.length ? $setup.data.angles[$setup.selectedIndex] : $setup.data.extra_photos[$setup.selectedIndex - $setup.data.angles.length],
          onChangeItem: $setup.openModal,
          onCloseModal: _cache[6] || (_cache[6] = () => ($setup.isShow = false))
        }, null, 8, ["total", "selected", "item", "onChangeItem"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}